exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.h5-components.main-box{min-width:300px}.h5-components .main-body{width:100%;padding:0 20px}.h5-components .body-content{padding:60px 0 40px}.h5-components .header-box{width:100%;height:60px;text-align:center}.h5-components .header-box .logo-box{padding-top:18px;left:0;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34b9bbbc","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/e-header.vue
// module id = 674
// module chunks = 0